import createAppTheme from '../../theme/createAppTheme';
import { buildBrandPalette } from '../../theme/buildBrandPalette';
import { DEFAULT_BRAND_COLORS } from '../../theme/brandTokens';

/** Marketing pages always use Salovare's own palette, never a store's. */
const landingTheme = createAppTheme(buildBrandPalette(DEFAULT_BRAND_COLORS));

export default landingTheme;
